import axios from "axios";
import api from "@/api";
const path = "/EntidadBancaria";

export default {
    getLista(obj) {
        return axios.get(`${api.alumnos + path}/GetLista`, { params: obj });
    }
};